<template>
  <CommonPopup
    v-model="visible"
    title="假定利率"
    class="interest_form_rate"
    height="77%"
    position="bottom"
    round
    closeable
    get-container="body"
    :show-cancel="false"
    @confirm="confirm"
  >
    <div class="content">
      <bxs-radio-group v-if="hasCustomRate" v-model="accountRate" class="radio_group">
        <bxs-radio
          v-for="o in rateOptions"
          :key="o.label"
          :name="o.value"
          data-stat-id="lyjdllqh"
          :data-stat-ep="JSON.stringify({
            key: o.stat
          })"
        >
          {{ o.label }}
        </bxs-radio>
        <bxs-radio
          class="defined_rate"
          name="defined"
          data-stat-id="lyjdll"
          :data-stat-ep="JSON.stringify({
            key: -1
          })"
        >
          <span>手动设定</span>
          <input
            v-model="rateInteger"
            type="tel"
            placeholder="请输入整数"
            maxlength="1"
            data-stat-id="lyjdllsdszzs"
            @input="rateInteger = (rateInteger || '').match(/\d/) ? rateInteger : ''; rateInteger && $refs.FractionalInput.focus()"
            @change="$refs.FractionalInput.focus()"
          >
          <span> . </span>
          <input
            ref="FractionalInput"
            v-model="rateFractional"
            type="tel"
            placeholder="00"
            maxlength="2"
            data-stat-id="lyjdllsdszxs"
            @input="rateFractional = rateFractional.match(/\d{1,2}/) ? rateFractional : ''"
          >
          <span> % </span>
        </bxs-radio>
      </bxs-radio-group>
      <template v-if="accountRateHistoryList && accountRateHistoryList.length">
        <p class="tips">
          历史利率 (数据仅供参考)
        </p>
        <table>
          <tr>
            <td> 结算年月 </td>
            <td> 结算利率 </td>
          </tr>
          <tr v-for="item in accountRateHistoryList" :key="item.settlementCycle">
            <td> {{ parseTime(item.settlementCycle, '{y}-{m}') }} </td>
            <td> {{ item.rate }} </td>
          </tr>
        </table>
      </template>
    </div>
  </CommonPopup>
</template>
<script>
import { get as _get } from 'lodash'
import { mapState } from 'vuex'
import CommonPopup from '@/components/common/common-popup/index.vue'
import { BottomSheets, RadioGroup, Radio } from 'bxs-ui-vue';
import { Toast } from 'vant'
import { parseTime } from '@/common/js/common.js'
export default {
  components: {
    CommonPopup,
    [BottomSheets.name]: BottomSheets,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    hasCustomRate: {
      type: Boolean
    },
    previousRate: {
      type: Number
    },
  },
  data () {
    return {
      accountRate: 'defined',
      rateInteger: null,
      rateFractional: null,
      isClickConfirm: false
    }
  },
  computed: {
    ...mapState({
      interestData: 'interestData'
    }),
    visible: {
      get () {
        this.initRate()
        return this.value
      },
      set (v) {
        if (v) {
          return
        }
        if (this.isClickConfirm) {
          this.isClickConfirm = false
          return
        }
        this.$emit('update', {
          rate: this.previousRate,
          isShowRatePopup: false
        })
      },
    },
    accountRateHistoryList () {
      return _get(this, 'interestData.curProductInterestData.accountRateHistoryList') || []
    },
    rateOptions () {
      const { accountRateHistoryList } = this
      if (!accountRateHistoryList) {
        return []
      }
      const options = []
      const latestMonth = [1, 12]
      latestMonth.forEach(k => {
        const tempList = accountRateHistoryList.slice(0, k)
        if (!(tempList && tempList.length)) {
          return []
        }
        const value = Number((tempList.reduce((a, b) => a + b.rate, 0) / tempList.length).toFixed(2))
        options.push({
          stat: k,
          value: Number((value / 100).toFixed(4)),
          label: k ===  1 ? `${value}%（${parseTime(tempList[0].settlementCycle, '{y}-{m}')}结算利率）` : `${value}%（近${k}月平均利率）`
        })
      })
      return options
    },
  },
  methods: {
    parseTime,
    initRate () {
      const { formData } = this
      if (!formData.customRate) {
        return
      }
      if (this.rateOptions.find(o => o.value === formData.customRate)) {
        this.accountRate = formData.customRate
      } else {
        this.accountRate = 'defined'
        const customRate = (formData.customRate * 100).toFixed(2)
        this.rateInteger = customRate.split('.')[0]
        this.rateFractional = customRate.split('.')[1]
      }
    },
    confirm () {
      const { accountRate, hasCustomRate, rateInteger, rateFractional } = this
      let tempRate = accountRate
      if (hasCustomRate) {
        if (tempRate === 'defined') {
          if (!rateInteger && !rateFractional) {
            Toast('请输入假定利率')
            return
          }
          const customRate = (rateInteger || '') + '.' + (rateFractional || '')
          tempRate = Number((customRate / 100).toFixed(4))
        }
        this.$emit('update', {
          rateIndex: -1,
          customRate: tempRate,
          isShowRatePopup: false
        })
        this.isClickConfirm = true
        return
      }
      this.$emit('update', {
        isShowRatePopup: false
      })
      this.isClickConfirm = true
    }
  }
}
</script>
<style>
@import './interest-form-rate.css';
</style>
